<div class="card-header bg-light">
  <h4 class="card-title mb-0">
    <i class="far fa-file"></i> Cancelar Constatação
  </h4>
</div>
<form [formGroup]="form" novalidate>
  <div class="card-body">
    <div class="p-2 wrapper">

      <div class="row mb-2">
        <div class="col-md-12 mt-2">
          <label class="form-label">
            Justificativa <span class="text-danger">*</span>
          </label>
          <textarea
            class="form-control"
            rows="5"
            maxlength="500"
            placeholder="Digite uma justificativa para o cancelamento"
            formControlName="justificativa"
            [ngClass]="{
              'is-invalid': form.controls['justificativa'].touched && form.controls['justificativa'].invalid
            }">
          </textarea>

          <div class="invalid-feedback"
               *ngIf="form.controls['justificativa'].touched && form.controls['justificativa'].invalid">
            <div *ngIf="form.controls['justificativa'].errors?.required">
              Justificativa é obrigatória.
            </div>
            <div *ngIf="form.controls['justificativa'].errors?.maxlength">
              Máximo de 500 caracteres.
            </div>
          </div>
          <small class="text-muted float-right mt-1">
            {{ form.get('justificativa')?.value?.length || 0 }} / 500
          </small>
        </div>
      </div>

    </div>
  </div>

  <div class="card-footer">
    <div class="d-flex w-100 justify-content-between align-items-center">

      <div>
        <button type="button"
                class="btn btn-danger"
                (click)="salvar()"
                [disabled]="form.invalid || loading">
          <i class="fas fa-ban"></i> Salvar
        </button>

        <button type="button"
                class="btn btn-default btn-sm ml-2"
                (click)="fechar()">
          <i class="fas fa-times"></i> Cancelar
        </button>
      </div>

    </div>
  </div>
</form>
